module.exports = __webpack_public_path__ + "img/Loginphoto.e692fb14.png";